/**
 * Central design tokens — update values here to reflect across the whole app.
 * Referenced by App.tsx (MUI theme) and individual components via import.
 */
export const designTokens = {
  colors: {
    primary: "#FE7915",
    primaryDark: "#E56A0D",
    secondary: "rgba(254, 121, 21, 0.35)",
    textPrimary: "#1A1A1A",
    textSecondary: "#4F5665",
    textMuted: "#9E9E9E",
    white: "#FFFFFF",
    background: "#FFFFFF",
    backgroundAlt: "#FAFAFA",
    backgroundDark: "#1A1A1A",
    footerBg: "#272727",
    footerBottom: "#000000",
    border: "#E8E8E8",
    featureBg: "#F5F5F5",
    success: "#2FAB73",
    error: "#F51B22",
    heroOverlay: "rgba(0, 0, 0, 0.4)",
  },

  fonts: {
    family: "'Montserrat', 'Roboto', sans-serif",
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    md: "1.125rem",
    lg: "1.25rem",
    xl: "1.5rem",
    h4: "2.25rem",
    h3: "2.5rem",
    h2: "3rem",
    heroTitle: { xs: "1.75rem", sm: "2rem", md: "2.5rem" },
    sectionTitle: { xs: "1.75rem", md: "2.25rem" },
    navLink: "1rem",
    button: "1rem",
    overline: "0.75rem",
  },

  spacing: {
    headerHeight: { xs: 64, md: 80 },
    heroHeight: { xs: 480, md: 585 },
    sectionPy: { xs: 2, md: 4 },
    containerMax: "xl" as const,
  },

  borderRadius: {
    sm: "4px",
    md: "8px",
    lg: "12px",
    pill: "50px",
    card: "8px",
  },

  company: {
    name: "Sundeus Technology",
    copyright: `© ${new Date().getFullYear()} by Sundeus Technology Pvt. Ltd`,
    sunduesAiUrl: "https://sundeus.ai",
  },

  navLinks: [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Products", path: "/contract-management" },
    { name: "About", path: "/about" },
    { name: "Careers", path: "/career" },
    { name: "Sundeus.ai", path: "https://sundeus.ai", external: true },
  ] as Array<{ name: string; path: string; external?: boolean }>,
};

export type DesignTokens = typeof designTokens;
